<template>
	<div>
		<div class="top_box">
			<div style="text-align: center;color: #ffffff;">
				<img src="../assets/logo_b.png" style="width: 172rem;height: 20rem;margin-top: 35rem;cursor: pointer;"/>
				<p style="font-size: 24rem;font-weight: 700;margin-top: 480rem;" class="font-apercu-bold">TEMPORARY SITE
				</p>
				<p style="margin-top: 40rem;font-size: 16rem;font-weight: 500;" class="font-apercu-medium">You can find
					us through the information below.</p>
				<p class="font-apercu-medium" style="font-size: 16rem;font-weight: 500;">Our new website is coming soon.
				</p>
			</div>
		</div>
		<div style="padding: 84rem 45rem;">
			<div style="float: left;width: 100%;">
				<div style="float: left;width: 30%;margin-left: 8%;">
					<div style="float: left;width: 40%;">
						<p class="ft_title font-apercu-bold" style="">GENERAL ENQUIRES
						</p>
					</div>
					<div style="float: left;width: 60%;">
						<p class="footer-description font-apercu-medium">
							info@den-holm.com
						</p>
						<p class="footer-description font-apercu-medium">
							+61 422 875 261
						</p>
					</div>
				</div>

				<div style="float: left;width: 30%;">
					<div style="float: left;width: 30%;">
						<p class="ft_title font-apercu-bold" style="">INSTAGRAM
						</p>
					</div>
					<div style="float: left;width: 70%;font-size: 14rem;">
						<a href="https://www.instagram.com/den_holm/" target="_blank"
							class="contact-link font-apercu-medium"
							style="display: block;text-decoration: none;">@den_holm</a>
						<a href="https://www.instagram.com/den_holmunited/" target="_blank"
							class="contact-link font-apercu-medium"
							style="display: block;text-decoration: none;">@den_holmunited</a>
					</div>
				</div>
				<div style="float: left;width: 30%;">
					<div style="float: left;width: 20%;">
						<p class="ft_title font-apercu-bold" style="">STUDIO
						</p>
					</div>
					<div style="float: left;width: 80%;font-size: 14rem;">
						<p class="font-apercu-medium">12 Fulton Street, Oakleigh South 3167</p>
						<p class="font-apercu-medium">Victoria, Australia</p>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import topBg from '../assets/contact/contact1.png'
	 
	export default {
		name: 'AboutPage',
		components: {

		},
		data() {
			return {
				topBg: topBg
			}
		},
		methods: {
			 
		}
	}
</script>

<style scoped>
	/* 基础样式 */
	.about-page {
		width: 100%;
		min-height: 100vh;
		background: #fff;
		font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
		color: #1a1a1a;
		position: relative;
	}



	.top_box {
		width: 100%;
		height: 700rem;
		max-height: 700rem;
		background-image: url('../assets/contact/contact1.png');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		display: flex;
		justify-content: center;
		/* align-items: center; */
	}

	.header-content {
		max-width: 800rem;
		margin: 0 auto;

	}

	.contact-link {

		color: #000;
		text-decoration: underline;
		transition: opacity 0.3s;
	}

	.footer-content {
		border: none;
	}

	.ft_title {
		font-family: Apercu Pro;
		font-weight: 700;
		font-style: Bold;
		font-size: 17rem;
		leading-trim: NONE;
		line-height: 100%;
		letter-spacing: -2%;
	}

	.page-title {
		font-size: 24rem;
		font-weight: 700;
		letter-spacing: -0.5rem;
		margin: 0 0 40rem 0;
		color: #000;
		line-height: 1.1;
		text-align: center;
	}

	.header-description {

		padding-top: 80rem;
	}

	.page-description {
		font-size: 18rem;
		line-height: 1.8;
		color: #444;
		margin: 0;
		font-weight: 350;
		text-align: justify;
	}

	/* 交替内容区域 */
	.alternating-sections {}

	.alternating-section {
		margin-bottom: 80rem;
	}

	/* 画廊网格布局 */
	.gallery-grid {
		display: grid;
		grid-template-columns: 2fr 1fr;
		gap: 24rem;
		margin-bottom: 60rem;
	}

	.gallery-item {
		position: relative;
		overflow: hidden;
		border-radius: 2rem;
		height: 400rem;
	}

	.gallery-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: transform 0.6s ease;
	}

	.gallery-item:hover .gallery-image {
		transform: scale(1.02);
	}

	/* 全宽区域 */
	.full-width-section {}

	.studio-image {

		border-radius: 2rem;
	}

	.footer-section {
		display: flex;
		flex-direction: column;
	}

	.mailing-list {
		max-width: 500rem;
	}

	.footer-title {
		font-size: 12rem;
		font-weight: 700;
		letter-spacing: 2rem;
		text-transform: uppercase;
		margin: 0 0 20rem 0;
		color: #000;
	}

	.footer-description {
		font-size: 14rem;
		/* line-height: 1.6; */
		margin: 0 0 5rem 0;
		color: #333;
	}

	.email-form {
		display: flex;
		align-items: baseline;
		gap: 5rem;
		border-bottom: 2rem solid #000;
		padding-bottom: 5rem;
	}

	.email-input {
		flex: 1;
		border: none;
		outline: none;
		font-size: 14rem;
		background: transparent;
		color: #000;
	}

	.email-input::placeholder {
		color: #666;
	}

	.submit-btn {
		background: none;
		border: none;
		font-size: 14rem;
		color: #000;
		cursor: pointer;
		padding: 0;
		font-family: inherit;
		transition: opacity 0.3s;
	}

	.submit-btn:hover {
		opacity: 0.7;
	}

	.submit-text {
		font-weight: 350;
	}

	/* 响应式设计 */
	@media (max-width: 1024rem) {
		.gallery-grid {
			grid-template-columns: 1fr;
			gap: 20rem;
		}

		.gallery-item {
			height: 500rem;
		}

		.sidebar-wrap {
			width: 40%;
		}
	}

	@media (max-width: 768rem) {
		.about-header {
			padding: 80rem 5% 60rem;
		}

		.page-title {
			font-size: 48rem;
		}

		.gallery-item {
			height: 400rem;
		}

		.studio-image {
			height: 500rem;
		}

		.alternating-sections {
			padding: 0 20rem;
		}

		/* 移动端：菜单全屏 */
		.sidebar-wrap {
			width: 100%;
		}
	}

	.footer-no-border ::v-deep .footer-content,
	.footer-no-border ::v-deep .footer-container,
	.footer-no-border ::v-deep .content-wrapper,
	.footer-no-border ::v-deep .footer-wrapper {
		border-top: none !important;
	}

	@media (max-width: 480rem) {
		.page-title {
			font-size: 36rem;
		}

		.page-description,
		.text-description {
			font-size: 16rem;
		}

		.gallery-item {
			height: 300rem;
		}

		.studio-image {
			height: 350rem;
		}
	}
</style>